import Link from "next/link";
import { useRouter } from "next/router";
import { useEffect } from "react";
import { useState } from "react";
import { connect } from "react-redux";
import { showToastAlert } from "../../redux/action/alert";
import { failToSubmit, succeedToSubmit } from "../../common/alert";
import { submitLoginForm } from "../../api/login";
import { getCookie } from "../../common/auth";
import { clearCart } from "../../redux/action/cart";
import styled from "styled-components";
import { insertBaskets } from "../../api/baskets";

const BtnWrapper = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  column-gap: 10px;
  row-gap: 10px;
`;

const PopupCheckoutBtn = styled.div`
  width: 100%;
  text-align: center;
  border: 2px solid #3bb77e;
  background-color: #fff;
  border-radius: 5px;
  padding: 10px;
  color: #7e7e7e;
  cursor: pointer;
  :hover {
    background-color: #3bb77e;
  }
  grid-column: span 1 / span 1;
`;

const PopupRegisterBtn = styled.button`
  width: 100%;
  text-align: center;
  border: 2px solid #3bb77e;
  background-color: #3bb77e;
  border-radius: 5px;
  padding: 10px;
  color: #fff;
  cursor: pointer;
  :hover {
    background-color: #3bb77e;
    opacity: 0.8;
  }
`;

const RegisterEventTooltip = styled.div`
  display: inline-block;
  position: relative;
  background-color: #fd7e14;
  color: #fff;
  padding: 5px 10px;
  border-radius: 5px;
  line-height: 1.2;
  word-break: keep-all;
  text-align: center;

  &::after {
    content: "";
    position: absolute;
    top: -15px;
    left: 50%;
    transform: translateX(-50%);
    border-width: 8px;
    border-style: solid;
    border-color: transparent transparent #fd7e14 transparent;
  }
`;

const ModalWrapper = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.8);
  z-index: 10000001;
  width: 100vw;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;

  .close {
    font-size: 16px;
    color: #696969;
    border: 2px solid #696969;
    border-radius: 50%;
    padding: 5px;
    :hover {
      color: #3bb77e;
      border: 2px solid #3bb77e;
    }
  }

  & strong {
    color: #e74c3c;
  }

  .modal-section {
    border-radius: 20px;
    background-color: white;
    overflow: auto;
    border: none;
    display: flex;
    flex-direction: column;
    padding: 15px;
    & > i {
      font-size: 2rem;
      color: black;
      cursor: pointer;
      :hover {
        color: #3bb77e;
      }
    }
  }

  .modal-content {
    width: 100%;
    display: flex;
    flex-direction: column;
    padding: 1rem;
    border: none;
    margin: 0 auto;
    overflow-y: auto;
    height: 100%;
    & h5 {
      font-size: 18px;
    }

    & a {
      width: 200px;
    }
  }

  .close_icon {
    cursor: pointer;
    width: 30px;
  }
`;

const RequestLoginModal = ({
  handleLoginModal,
  openLoginModal,
  showToastAlert,
  cartItems,
  clearCart,
  purchaseDirect,
  product,
  cnt,
  carbon,
  onClickLogin,
}) => {
  globalThis.onkeydown = (e) => {
    if (e.code === "Escape") return handleLoginModal();
  };
  const router = useRouter();
  const [isUidRemembered, setIsUidRemembered] = useState(false);
  const [inputValues, setInputValues] = useState({
    uid: "",
    upass: "",
  });

  // 정보 입력 상태 관리
  const inputHandler = (e) => {
    const { name, value } = e.target;

    setInputValues({
      ...inputValues,
      [name]: value,
    });
  };

  // 아이디 토큰 확인
  const findUidCookie = () => {
    if (getCookie("uid") === undefined) {
      return;
    } else if (getCookie("uid") !== undefined) {
      setInputValues({ uid: getCookie("uid") });
      return setIsUidRemembered(true);
    }
  };

  // 아이디 기억하기 체크 유무
  const rememberUidHandler = () => {
    setIsUidRemembered(!isUidRemembered);
  };

  // 로그인폼 제출
  const submitHandler = async (e) => {
    e.preventDefault();

    if (!inputValues.uid) {
      return showToastAlert("아이디를 입력해주세요!", failToSubmit);
    } else if (!inputValues.upass) {
      return showToastAlert("비밀번호를 입력해주세요!", failToSubmit);
    }

    const body = {
      modes: "Login",
      uid: inputValues.uid,
      upass: inputValues.upass,
    };

    const response = await submitLoginForm(body, isUidRemembered);

    if (response === "Success") {
      showToastAlert("환영합니다!", succeedToSubmit);
      if (onClickLogin) {
        onClickLogin();
        return;
      }
      if (cartItems?.length > 0) {
        const body = {
          modes: "InsertSet",
          items: JSON.stringify(cartItems),
        };
        const res = await insertBaskets(body);
        clearCart();
      }
      handleLoginModal();
      sessionStorage.setItem(
        "directOrder",
        JSON.stringify([{ ...product, cnt: cnt }])
      );
      router.push({
        pathname: "/checkout",
        query: {
          type: "direct",
        },
      });
      return;
    } else {
      return showToastAlert(response, failToSubmit);
    }
  };

  useEffect(() => {
    findUidCookie();
  }, []);

  return (
    <>
      <ModalWrapper>
        <div className="modal-section">
          <div className="modal-content">
            <div className="col-lg-12 col-12 m-auto">
              <div className="login_wrap widget-taber-content background-white">
                <div className="padding_eight_all bg-white">
                  <div className="heading_s1 ">
                    <div className="d-flex align-items-center justify-content-between">
                      <h1 className="mb-5">로그인 </h1>
                      <img
                        src="/assets/imgs/page/common/modal_close_icon.png"
                        alt="modal_close_icon"
                        onClick={onClickLogin ? onClickLogin : handleLoginModal}
                        className="close_icon"
                      />
                    </div>
                    <p
                      className="mb-20 mt-10"
                      style={{ wordBreak: "keep-all" }}
                    >
                      로그인하여 구매하시면 포인트 적립 1% 및 쿠폰 사용이
                      가능합니다.
                    </p>
                  </div>
                  <form onSubmit={submitHandler}>
                    <div className="form-group">
                      <input
                        name="uid"
                        type="text"
                        required=""
                        placeholder="아이디"
                        defaultValue={inputValues.uid}
                        onChange={inputHandler}
                        className="form-input"
                      />
                    </div>
                    <div className="form-group">
                      <input
                        name="upass"
                        type="password"
                        required=""
                        placeholder="비밀번호"
                        onChange={inputHandler}
                        className="form-input"
                      />
                    </div>
                    <div className="login_footer form-group mb-10">
                      <div className="chek-form ">
                        <div className="custome-checkbox">
                          <input
                            className="form-check-input"
                            type="checkbox"
                            name="checkbox"
                            id="exampleCheckbox1"
                            value=""
                            checked={isUidRemembered}
                            onChange={rememberUidHandler}
                          />
                          <label
                            className="form-check-label"
                            htmlFor="exampleCheckbox1"
                          >
                            <span>아이디 기억하기</span>
                          </label>
                        </div>
                      </div>
                    </div>
                    <div className="form-group">
                      <button
                        type="submit"
                        className="btn btn-heading col-12"
                        name="login"
                      >
                        로그인
                      </button>
                    </div>
                  </form>
                </div>
                {!carbon && (
                  <BtnWrapper>
                    <PopupCheckoutBtn
                      className="btn btn-heading btn-block"
                      onClick={purchaseDirect(product)}
                    >
                      비회원 구매하기
                    </PopupCheckoutBtn>

                    <PopupRegisterBtn
                      className="btn btn-heading btn-block"
                      onClick={() => {
                        router.push("/register");
                      }}
                    >
                      회원가입
                    </PopupRegisterBtn>
                    <span></span>
                    <RegisterEventTooltip>
                      지금 가입하고, 최대 5만원 웰컴 쿠폰팩 받으세요!
                    </RegisterEventTooltip>
                  </BtnWrapper>
                )}
              </div>
            </div>
          </div>
        </div>
      </ModalWrapper>
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    cartItems: state.cart,
  };
};

const mapDispatchToProps = {
  showToastAlert,
  clearCart,
};

export default connect(mapStateToProps, mapDispatchToProps)(RequestLoginModal);
